import { render, staticRenderFns } from "./CasesPage.vue?vue&type=template&id=2fed583b"
import script from "./CasesPage.vue?vue&type=script&lang=js"
export * from "./CasesPage.vue?vue&type=script&lang=js"
import style0 from "./CasesPage.vue?vue&type=style&index=0&id=2fed583b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports